import { StoredFilterItem } from "../../../entities/Filter/StoredFiltersResponse";
import { Cast } from "../../../utils/Utils";
import { ReportId, TYPE_REPORT } from "../../shared/components/AdvancedFilters";

export const GROUPING_REPORT_ID = Cast<ReportId>(
  TYPE_REPORT.GroupAgingGrouping
);
export const NO_GROUPING = -1;

const GROUP_BY_PARAM = "groupby";
const DEFAULT_PARAM = "default";

export const parseGroupingFilter = (filter: string): number[] =>
  (new URLSearchParams(filter).get(GROUP_BY_PARAM) ?? "")
    .split(",")
    .map((x) => parseInt(x))
    .filter((x) => !isNaN(x) && x !== 0);

export const isDefaultGrouping = (filter?: string) =>
  new URLSearchParams(filter ?? "").get(DEFAULT_PARAM) === "1";

export const buildGroupingFilter = (ids: number[], isDefault = false) =>
  GROUP_BY_PARAM +
  "=" +
  ids.join(",") +
  (isDefault ? "&" + DEFAULT_PARAM + "=1" : "");

export const withGroupingDefault = (filter: string, isDefault: boolean) =>
  buildGroupingFilter(parseGroupingFilter(filter), isDefault);

// Only the user's own private groupings can be opened by default.
export const isOwnPrivateGrouping = (
  grouping: Partial<StoredFilterItem>,
  userId: number
) => grouping.Private === true && grouping.UserID === userId;

export const findDefaultGrouping = (
  groupings: StoredFilterItem[],
  userId: number
) =>
  groupings.find(
    (x) => isOwnPrivateGrouping(x, userId) && isDefaultGrouping(x.Filter)
  );
